import { format, parseISO } from 'date-fns';
import React, { type ReactElement } from 'react';
import { TimeElement } from '../TimeElement/TimeElement';

interface BikeLightsProps {
    region: string;
}

interface BikeLightsState {
    sunrise: string;
    sunset: string;
    error: boolean;
}

export class BikeLights extends React.Component<BikeLightsProps, BikeLightsState> {
    constructor(props: BikeLightsProps) {
        super(props);
        this.state = {
            sunrise: null,
            sunset: null,
            error: false,
        };
    }

    componentDidMount(): void {
        fetch(`/api/external/sun?region=${this.props.region}`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }

                this.setState({
                    sunrise: data.sunrise,
                    sunset: data.sunset,
                });
            })
            .catch(() => {
                this.setState({ error: true });
            });
    }

    render(): ReactElement {
        const { sunrise, sunset, error } = this.state;
        const sunriseISO: Date | null = sunrise ? parseISO(sunrise) : null;
        const sunsetISO: Date | null = sunset ? parseISO(sunset) : null;

        return (
            <span role="log" aria-live="polite">
                {error && <></>}
                {!error && !sunriseISO && !sunsetISO ? (
                    <span>Laddar cykellystider...</span>
                ) : (
                    !error && (
                        <span>
                            Använd cykellyset{' '}
                            <b>
                                före kl. <TimeElement date={sunriseISO}>{format(sunriseISO, 'HH.mm')}</TimeElement>
                            </b>{' '}
                            och
                            <b>
                                {' '}
                                efter kl. <TimeElement date={sunsetISO}>{format(sunsetISO, 'HH.mm')}</TimeElement>
                            </b>
                        </span>
                    )
                )}
            </span>
        );
    }
}
